const CODE = {
  DONE: '000',
};

export default {
  CODE,
  CODE_TOKEN_EXPIRED: 40115,
  STATUS_UNAUTHORIZE: 401,
};
